<button
  class="ag1-button-small flex items-center justify-center gap-3"
  [class]="'ag1-button--' + variant() + ' ' + (classOverrides() || '')"
  [class.flex-row]="position() !== 'right'"
  [class.flex-row-reverse]="position() === 'right'"
  [class.ag1-button--active]="isActive()"
  [ag1Tooltip]="tooltip"
  [tooltipPosition]="tooltipPosition"
  [tooltipTemplateRef]="tooltipTemplateRef"
  [tooltipHasArrow]="tooltipHasArrow"
  [tooltipVariant]="variant"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <ng-content />
  @if (label()) {
    <span>
      @if (!formatWithSentenceCase()) {
        {{ label() }}
      }
      @if (formatWithSentenceCase()) {
        {{ label() | sentenceCase }}
      }
    </span>
  }
</button>
